import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';

class ImportFormButtons extends PureComponent {
  static propTypes = {
    company: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    subcompany: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <div className="row mt-3">
      <div className="col-md-12">
        <Form.Button
          text={this.props.t('actions.save')}
          isLoading={this.props.isLoading}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={`/companies/${this.props.company.id}/subcompanies/${this.props.subcompany.id}/import`}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: this.props.isLoading,
          })}
        >
          {this.props.t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </div>
  );
}

export default translate()(ImportFormButtons);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/form/ImportFormButtons.js